export * from './product-list.component.jsx';


// WEBPACK FOOTER //
// ./src/components/product_list/index.js